import React, { forwardRef } from 'react';

import { FontSizeKeys } from '../styles/themes';
import { Text } from '../Text';
import { getConfidenceLevelColor } from '../utils/getConfidenceLevelColor';

type ConfidenceLevelProps = {
  value: number;
  fontSize?: FontSizeKeys;
  textAlign?: 'left' | 'center' | 'right';
};

const ConfidenceLevelIndicator = forwardRef(
  (
    { value, fontSize = 14, textAlign = 'left' }: ConfidenceLevelProps,
    ref: React.Ref<HTMLParagraphElement>
  ) => {
    return (
      <Text
        ref={ref}
        fontSize={fontSize}
        color={getConfidenceLevelColor(value)}
        textAlign={textAlign}
        fontWeight="bold"
      >
        {value}
      </Text>
    );
  }
);

export { ConfidenceLevelIndicator };
